import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRightFromBracket,
  faChartLine,
  faGraduationCap,
  faGear,
  faShieldHalved,
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../contexts/AuthContext';

const AppSidebar: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user, logout } = useAuth();

  const isAdminUser = ['MANAGER', 'ADMIN', 'SUPER_ADMIN'].includes(user?.role || '');

  const navItems = [
    { path: '/dashboard', icon: faChartLine, title: 'Dashboard' },
    { path: '/training', icon: faGraduationCap, title: 'Training' },
    { path: '/settings', icon: faGear, title: 'Settings' },
  ];

  return (
    <aside className="wti-sidebar">
      <div>
        <div className="wti-logo">wti</div>
        <nav className="wti-sidebar-nav">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`wti-sidebar-item${pathname === item.path || pathname.startsWith(`${item.path}/`) ? ' wti-sidebar-item--active' : ''}`}
              type="button"
              title={item.title}
              onClick={() => navigate(item.path)}
            >
              <span className="wti-sidebar-item-dot">
                <FontAwesomeIcon icon={item.icon} />
              </span>
            </button>
          ))}
          {isAdminUser && (
            <button
              className={`wti-sidebar-item${pathname === '/admin' ? ' wti-sidebar-item--active' : ''}`}
              type="button"
              title="Admin"
              onClick={() => navigate('/admin')}
            >
              <span className="wti-sidebar-item-dot">
                <FontAwesomeIcon icon={faShieldHalved} />
              </span>
            </button>
          )}
        </nav>
      </div>
      <button type="button" className="wti-sidebar-logout" onClick={logout}>
        <span className="wti-sidebar-logout-icon">
          <FontAwesomeIcon icon={faRightFromBracket} />
        </span>
      </button>
    </aside>
  );
};

export default AppSidebar;
